
import { Component, Mixins } from "vue-property-decorator";
import { PaintStyle, Color } from "../../../../../../base/domain/drawing";
import { ITextureStylePropertyEditable, instanceOfITextureStylePropertyEditable, ILineStylePropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class TextureStylePropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: ITextureStylePropertyEditable & ILineStylePropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ITextureStylePropertyEditable & ILineStylePropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isTextureStyleEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfITextureStylePropertyEditable(s) && s.textureStyle().isEditable(), false);
  }

  get textureStyle(): PaintStyle {
    // DocuMakerフォーマット仕様(というよりv1フォーマット編集実装仕様)に基づき前景色を使う.
    return this.readPropertyOrDefault(s => new PaintStyle(Color.from(s.lineStyle().getValue().color), s.textureStyle().getValue().kind), new PaintStyle());
  }

  set textureStyle(value: PaintStyle) {
    // DocuMakerフォーマット仕様(というよりv1フォーマット編集実装仕様)に基づき前景色を使う.
    this.writePropertyWhenValid(s => {
      s.textureStyle().setValue({ kind: value.kind });
      const lineStyle = s.lineStyle().getValue();
      s.lineStyle().setValue({
        kind: lineStyle.kind,
        width: lineStyle.width,
        color: value.color,
        opacity: 1,
      });
    });
  }
}
